import React, { useMemo } from 'react';
import { Icon } from '@ontruck/orc';
import cx from 'classnames';
import { useOrderStop } from 'components/orders/OrderStop/UseOrderStop';

const ProgressBar = ({ className }) => {
  const {
    isDone,
    isStandstill,
    isPossibleStandstill,
    isInProgress,
    isLastStop,
  } = useOrderStop();

  const { style, icon } = useMemo(() => {
    if (isDone) {
      return {
        style: isLastStop ? 'done' : 'to-next',
        icon: 'check',
      };
    }
    if (isInProgress) {
      return {
        style:
          isStandstill || isPossibleStandstill
            ? 'in-standstill'
            : 'in-progress',
      };
    }
    return {};
  }, [isLastStop, isDone, isStandstill, isPossibleStandstill, isInProgress]);

  return (
    <div
      className={cx(className, style)}
      data-testid={`progress-bar__${style || ''}`}
    >
      <div className="prev-step" />
      <div className="current-step">
        <div className="state">
          {icon && (
            <Icon glyph={icon} size="10px" color="white" data-testid="icon" />
          )}
        </div>
      </div>
      <div className="next-step" />
    </div>
  );
};

export default ProgressBar;
